/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class ReviewsAssignedReviewDetailsRoute extends Route {
  analytics = {
    section: 'inbox',
    place: 'reviews.assigned.review.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ReviewsAssignedReviewDetailsRoute);
